export default {
  common: {
    button: {
      cancel: 'Cancel',
      clear: 'Clear',
      close: 'Close',
      done: 'Done',
      getStarted: 'Get started',
      next: 'Next',
      ok: 'OK',
      logOut: 'Log out',
      register: 'Register',
      reset: 'Reset',
      update: 'Update',
      leaveFeedback: 'Leave feedback',
      yes: 'Yes',
      no: 'No',
      switchUser: 'Switch user'
    },
    connectivity: {
      offline: 'Offline',
      online: 'Online'
    },
    emoji: {
      bad: 'Bad',
      good: 'Good',
      neutral: 'Neutral',
      perfect: 'Perfect',
      worst: 'Worst'
    },
    misc: {
      copyright: '© 125 Data & Insights Ltd',
      fibLtd: '125 Data & Insights Limited',
      findOutMore: 'Find out more',
      licenseInfo: 'License Information',
      loading: 'Loading',
      miles: 'Miles',
      privacyPolicy: 'Platform privacy notice',
      total: 'Total'
    },
    placeholder: {
      addYourComments: 'Add your comments...'
    },
    social: {
      email: 'Email',
      facebook: 'Facebook',
      google: 'Google',
      tripadvisor: 'Tripadvisor',
      twitter: 'Twitter'
    },
    validation: {
      alphaNumDashes: 'This field may only contain characters a-z, A-Z, hyphens, underscores and numbers 0-9.',
      alphaNumLower: 'This field may only contain characters a-z and numbers 0-9.',
      anniversary: 'This field must contain a valid date in the format DD/MM',
      DDMM: 'The date must be formatted day/month: (dd/mm)',
      DDMMYYYY: 'The date must be formatted day/month/year. (dd/mm/yyyy)',
      email: 'This field must contain a valid email address',
      futureDateNotAllowed: 'Date cannot be in the future',
      match: 'This field must contain a matching value',
      max: 'This field cannot contain more than {n} characters',
      min: 'This field must contain at least {n} characters',
      numeric: 'This field may only contain numbers 0-9',
      required: 'Required',
      validationFailed: 'Validation failed',
      validationSuccessful: 'Validation successful',
      minValue: 'Value must be {n} or above'
    }
  }
};